/**
 * -----------------------------------------------------------------------------
 * These endpoints communicate to services providing b2b resources.
 * -----------------------------------------------------------------------------
 */

import { IPaginationParams } from '../types';

/**
 * This `b2b service` endpoint for fetching all admin requests.
 */
export const fetchAllAdminRequestsUrl = () => '/b2b/admin/all-request';

/**
 * This `b2b service` endpoint handling submission of the contact us form
 * information
 */
export const contactUsUrl = () => '/b2b/contact-us';

/**
 * It returns the endpoint of the enterprise requests data.
 */
export const fetchEnterpriseMyRequestsListUrl = () =>
  '/api/enterprise/my-requests';

/**
 * It returns the endpoint of the enterprise requests details data.
 */
export const fetchEntMyRequestByIdUrl = (
  id: string,
  activities: boolean = false
) => `/api/enterprise/my-requests/${id}${activities ? '?activities=true' : ''}`;

/**
 * This `b2b service` endpoint handling submission of the sign up form
 * information
 */
export const postSignUpUrl = () => '/api/enterprise/register';

/**
 * The `b2b service` endpoint to get all the signup requests.
 */
export const fetchSignupListingUrl = ({ page, limit }: IPaginationParams) =>
  `/api/sign-ups-listing?page=${page}&limit=${limit}`;

/**
 * This `b2b service` endpoint handling submission of the create account form
 * information
 */
export const postCreateAccountUrl = () => '/api/create-account';

/**
 * This `b2b service` endpoint uses to fetch the recent customer quotes.
 */
export const fetchRecentCustomerQuotes = () => '/api/recent-customer-quotes';

/**
 * This `b2b service` endpoint uses to fetch the quote requests.
 */
export const fetchAdminQuoteRequestsListUrl = (page: number | unknown) =>
  `/api/quote-request?page=${page}`;

/**
 * This `b2b service` endpoint uses to fetch the quote details from id.
 */
export const fetchQuoteDetailsUrl = (id: string, type: string) =>
  `/api/quote-request/${id}?type=${type}`;

/**
 * This `b2b service` endpoint uses to fetch the admin quote details from id.
 */
export const fetchAdminQuoteDetailsUrl = (id: string, type: string) =>
  `/api/admin/quote-request/${id}?type=${type}`;

/**
 * This `b2b service` endpoint uses to fetch the all country list.
 */
export const fetchCountryListUrl = () => '/api/country-list';

/**
 * This `b2b service` endpoint uses to fetch the signup data.
 */
export const fetchCompleteRegistrationUrl = (token: string) =>
  `/api/enterprise/complete-registration?token=${token}`;
